import { USER_ROLE } from '../../utils/constants';
import AddUpdateClinic from './DoctorClinics/addUpdateClinic';
import DoctorsListing from './DoctorsListing';
import HealthCareFacilityDetails from './HealthCareFacilityDetails';
import HealthCareFacilityList from './HealthCareFacilityList';
import UpdateHealthCareFacility from './HealthCareFacilityList/updateHealthCareFacility';
import UpdateDoctor from './UpdateDoctor';
import DoctorDetail from './doctorDetails';
import HEALTHCARE_LINKS from './links';
import MedicinesListing from './medicine';
import UpdateMedicine from './medicine/updateMedicine';

export default [
  // Doctor
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_DOCTORS_LISTING,
    exact: true,
    component: DoctorsListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_ADD_DOCTOR,
    exact: true,
    component: UpdateDoctor,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_EDIT_DOCTOR,
    exact: true,
    component: UpdateDoctor,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_DOCTOR_DETAILS,
    exact: true,
    component: DoctorDetail,
    role: [USER_ROLE.ADMIN],
  },

  // Health care
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_HEALTH_CARE_LISTING,
    exact: true,
    component: HealthCareFacilityList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_ADD_HEALTH_CARE,
    exact: true,
    component: UpdateHealthCareFacility,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_EDIT_HEALTH_CARE,
    exact: true,
    component: UpdateHealthCareFacility,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_HEALTHCARE_DETAILS,
    exact: true,
    component: HealthCareFacilityDetails,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_EDIT_CLINIC,
    exact: true,
    component: AddUpdateClinic,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.HEALTHCARE_MODULE_ADD_CLINIC,
    exact: true,
    component: AddUpdateClinic,
    role: [USER_ROLE.ADMIN],
  },

  // Medicines
  {
    path: HEALTHCARE_LINKS.MEDICINES_LISTING,
    exact: true,
    component: MedicinesListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.ADD_MEDICINE,
    exact: true,
    component: UpdateMedicine,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: HEALTHCARE_LINKS.EDIT_MEDICINE,
    exact: true,
    component: UpdateMedicine,
    role: [USER_ROLE.ADMIN],
  },
];
